import { render, staticRenderFns } from "./Exclamation.vue?vue&type=template&id=0fc1cc4f&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc1cc4f')) {
      api.createRecord('0fc1cc4f', component.options)
    } else {
      api.reload('0fc1cc4f', component.options)
    }
    module.hot.accept("./Exclamation.vue?vue&type=template&id=0fc1cc4f&", function () {
      api.rerender('0fc1cc4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Exclamation.vue"
export default component.exports